import util from './util'

/*
	Identity for boxart. Guests can play and have their daily progress kept in
	localStorage; signing in (geekgroup OIDC, Google, or passwordless email)
	gives a boxart account with its OWN session token, kept in localStorage as
	`boxart.session`, so streaks/results follow the player across devices.

	A device token() keys an anonymous player; the boxart session token is the
	signed-in account credential, sent in the JSON body as `auth`.
*/

export default {

	// an anonymous device token, minted once and remembered
	token: function() {

		var token = localStorage.getItem('boxart.token')

		if (!token) {

			token = util.token()

			localStorage.setItem('boxart.token', token)

		}

		return token

	},

	// existing geekgroup token cookie on .geekgroup.app — recognised hosts can
	// skip the connect step
	geekgroup: function() {

		var match = document.cookie.match(/(?:^|;\s*)token=([a-z0-9]{32})/i)

		return match ? match[1] : false

	},

	// the shared .geekgroup.app cookie domain when we're on it; host-only
	// (e.g. localhost) otherwise
	domain: function() {

		return /(?:^|\.)geekgroup\.app$/.test(window.location.hostname) ? '; domain=.geekgroup.app' : ''

	},

	setGeekgroup: function(token) {

		document.cookie = 'token=' + token + '; path=/' + this.domain() + '; max-age=' + (60 * 60 * 24 * 365)

	},

	clearGeekgroup: function() {

		document.cookie = 'token=; path=/' + this.domain() + '; max-age=0'

	},

	// boxart's OWN session token (from an OIDC / email / Google sign-in), kept
	// in localStorage. Distinct from the device token() and the geekgroup cookie.
	session: function() {

		return localStorage.getItem('boxart.session') || false

	},

	setSession: function(token) {

		if (token) localStorage.setItem('boxart.session', token)

	},

	clearSession: function() {

		localStorage.removeItem('boxart.session')

	}

}
